import React from "react";
import { Button } from "@mui/material";
import styled from "@emotion/styled";

const StyledButton = styled(Button)({
    background: "linear-gradient(147deg, #000000 0%, #434343 74%)",
    color: "white",
    m: 0,
    "&:hover": {
        color: "black",
        outline: "1px solid black",
        background: "none",
        m: 0,
    },
    "&.Mui-disabled": {
        background: "grey",
    },
});

export default function GreyButton(props) {
    return (
        <StyledButton {...props} variant="contained">
            {props.children}
        </StyledButton>
    );
}
